module.exports = __webpack_public_path__ + "static/img/PS-NA2.c8fe381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PS-NA2.png
// module id = AKUU
// module chunks = 1